import { makeStyles } from '@material-ui/core/styles';
import { globalStyles } from 'GlobalStyles';

export const useStyles = makeStyles(
  theme => ({
    rowsContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(1.25, 2.5),
      backgroundColor: theme.palette.customColors.appBackgroundContrast
    },
    footerSkeletonBar: {
      marginTop: theme.spacing(2)
    },
    skeletonItemContainer: {
      width: '100%'
    },
    skeletonItem: {
      ...globalStyles.profileSkeletonItem
    },
    skeletonRow: {
      ...globalStyles.skeletonContainer
    },
    circleSkeleton: {
      borderRadius: '50%'
    },
    headerSkeleton: {
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      justifyContent: 'flex-start',
      padding: theme.spacing(3, 4),
      width: '100%'
    }
  }),
  { name: 'MuiSkeletonList' }
);
